module.exports = __webpack_public_path__ + "img/empty_icon01.6fc7a424.png";